<template>
	<AppCardPage>
		<AppCard title="Pensioenadvies" card-id="pensioenadvies-intro">
			<div class="pensioenadvies-card-content">
				<p>
					Deze module wordt het startpunt voor pensioenadvies binnen het
					dossier.
				</p>
				<p>
					In de volgende fase koppelen we hier afgeleide gegevens uit
					inventarisatie aan een net-first pensioenberekening.
				</p>
			</div>
		</AppCard>
	</AppCardPage>
</template>

<style scoped>
.pensioenadvies-card-content {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	max-width: 42rem;
}
</style>
